import { useContext, useEffect } from 'react'
import BulkEditModeContext from 'shared/components/context/bulk-edit-mode'
import ModalContext from 'shared/components/context/modal'
const BulkEditLauncher = () => {
    const { isBulkEditMode } = useContext(BulkEditModeContext)
    const { openBulkEditPanel } = useContext(ModalContext)
    useEffect(() => {
        if (isBulkEditMode) {
            openBulkEditPanel(isBulkEditMode)
        }
    }, [])
    return null
}
export default BulkEditLauncher
